import React, { FC, Fragment } from 'react';
import { Vector } from '../types';
import { Box } from './Box';
import { countNeighbors } from '../utils';

export type GlyphProps = {
  matrix: number[][];
  colors: string[];
  position?: Vector;
  rotation?: Vector;
  groupRef?: (el: any) => void;
  pixelRef?: (el: any, i: number) => void;
  scale?: number;
};

export const Glyph: FC<GlyphProps> = ({
  matrix,
  colors,
  position,
  rotation,
  groupRef,
  pixelRef,
  scale,
}) => {
  return (
    <group position={position} rotation={rotation} scale={scale} ref={groupRef}>
      {matrix.map((row, y) =>
        row.map((v, x) => {
          const color = v
            ? colors[0]
            : countNeighbors(matrix, x, y)
            ? colors[1]
            : null;
          return (
            color && (
              <Fragment key={`${x}_${y}`}>
                <Box
                  ref={pixelRef && ((el: any) => pixelRef(el, y * 10 + x))}
                  position={[x, 9 - y, 0]}
                  color={color}
                />
                <Box
                  ref={pixelRef && ((el: any) => pixelRef(el, y * 10 + 9 - x))}
                  position={[9 - x, 9 - y, 0]}
                  color={color}
                />
              </Fragment>
            )
          );
        }),
      )}
    </group>
  );
};
